import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { Layout, PageLoader } from './components'

import {
  AuthProvider,
  ContractProvider,
  useAuth,
  useContract,
  IuguWalletProvider
} from './contexts'

import {
  Dashboard,
  Home,
  Login,
  RecoverPassword,
  Wallet,
  FirstAccess,
  UnifiedEnergyBill
} from './pages'
import { ContractList } from './pages/ContractList'
import { CreateIuguWallet } from './urls'
import { FloatButton } from './components/FloatButton'

const PrivateRoute = () => {
  const { authUser, getUserIsLoading } = useAuth()

  if (getUserIsLoading) return <PageLoader />

  if (authUser) return <Outlet />

  return <Navigate to='/' />
}

const ContractGuardRoute = () => {
  const { selectedContract, contractsIsLoading } = useContract()

  if (contractsIsLoading) return <PageLoader />

  if (selectedContract) return <Outlet />

  return <Navigate to='/app/contracts' />
}


export const App = () => {

  return (
    <Routes>
      {/* <Route path='/criar-carteira/:hash' element={<IuguWalletProvider><CreateIuguWallet /></IuguWalletProvider>} /> */}

      <Route element={<><AuthProvider><Outlet /></AuthProvider></>}>

        <Route path='/' element={<Login />} />
        <Route path='/first-access' element={<FirstAccess />} />
        <Route path='/recover-password' element={<RecoverPassword />} />

        <Route path='/app' element={
          <ContractProvider>
            <Layout>
              <PrivateRoute />
              <FloatButton />
            </Layout>
          </ContractProvider>
        }>

          <Route path='contracts' element={<ContractList />} />

          <Route path='contracts/:contractId/*' element={<ContractGuardRoute />}>
            <Route index element={<Home />} />
            <Route path='dashboard' element={<Dashboard />} />
            {/* <Route path='wallet' element={<Wallet />} /> */}
            {/* <Route path='unified-energy-bill' element={<UnifiedEnergyBill />} /> */}
            <Route path='*' element={<Navigate to='/app' />} />
          </Route>

        </Route>
      </Route>
    </Routes>
  )
}
